import Translate from "utils/Translate";
import { AppContext } from "contexts/AppContext";
import { useContext } from "react";

const ContentLarge = (props) => {
    const { styleGuide } = useContext(AppContext)
    const contentLargeStyle = {
      fontFamily: styleGuide.secondaryFontFamily,
      fontWeight: styleGuide.contentLargeFontWeight,
      fontSize: styleGuide.contentLargeFontSize,
      fontStyle: 'normal',
      lineHeight: styleGuide.contentLargeLineHeight,
      color: styleGuide.color7
    }
  
    return (
      <span onClick={props.onClick} style={{...contentLargeStyle, ...props.style}} className={props.className}>
        { props.configuredLabel ? <span>{props.configuredLabel}</span> : <Translate translationKey={props.translationKey}>{props.fallbackText || props.children}</Translate>}
      </span>
    )
}

export default ContentLarge;